export const GLOBALS = {
  theme: process.env.THEME,
  firebase: process.env.FIREBASE_URL,
  gtm: process.env.GTMID,
};
